import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { EventsProvider } from './Context/EventsContext.jsx';
import { NewsProvider } from './Context/NewsContext.jsx';
import { AnnouncementsProvider } from './Context/AnnouncementsContext.jsx';

ReactDOM.render(
  <BrowserRouter>
    <EventsProvider>
      <NewsProvider>
        <AnnouncementsProvider>
          <App />
        </AnnouncementsProvider>
      </NewsProvider>
    </EventsProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

